import React, { ReactNode } from "react"
import styled from "styled-components"
import { Column } from "ui/components/atoms/_atoms"
import Button from "ui/components/atoms/button"
import Spinner from "ui/components/atoms/spinner"
import { LabelH3, P } from "ui/components/atoms/typography"

const LoadingContainer = ({
  isLoading,
  children,
  isEmpty,
  empty,
}: {
  isLoading: boolean
  children: ReactNode
  isEmpty?: boolean
  empty?: {
    title: string
    text: string
    buttonText?: string
    onClick?: () => void
  }
}) => {
  return (
    <Wrapper>
      {children}
      {isEmpty && empty && (
        <Column $alignItems="center" $justifyContent="center" $marginTop="XL">
          <LabelH3 $justifyContent="center" $marginBottom="XS">
            {empty?.title}
          </LabelH3>
          {empty?.text && <P $small>{empty?.text}</P>}
          {empty?.buttonText && (
            <Button $marginTop="S" $type="secondary" onClick={empty?.onClick}>
              {empty?.buttonText}
            </Button>
          )}
        </Column>
      )}
      {isLoading && (
        <Background>
          <Spinner />
        </Background>
      )}
    </Wrapper>
  )
}

export default LoadingContainer

const Background = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(255, 255, 255, 0.3);
`

const Wrapper = styled.div`
  position: relative;
  min-height: 200px;
`
